export const environment = {
    production: false,
    api: 'https://venzr-api-v2-dev.azurewebsites.net'
  };
  